import { useSelector } from "react-redux";
import { RootState } from "@reducers/rootReducer";
import { useGetProjectByIdQuery } from "@generated";
import { Project } from "../../types";

const useGetProjectById = (id) => {
  const { accountSlug } = useSelector((state: RootState) => state.slug);

  let customError: string | null = null; // Declare customError

  const { data, isLoading, error } = useGetProjectByIdQuery({
    slug: accountSlug,
    id,
    include: ["project-locations", "rate-table"],
  });

  let project: Project | undefined = undefined;

  if (data?.data) {
    try {
      const p = data.data;
      if (p?.id && p?.relationships) {
        project = {
          id: p.id,
          locations:
            p.relationships?.["project-locations"]?.data?.map((l) =>
              Number(l.id)
            ) || [],
          rateTableId: p.relationships?.["rate-table"]?.data?.id,
        };
      }
    } catch (err) {
      if (err instanceof Error) {
        customError = err.message;
      } else {
        customError = "An unknown error occurred";
      }
    }
  }

  return {
    project,
    isLoading,
    error: error ?? customError,
  };
};
export default useGetProjectById;
